<style lang="scss" scoped>
input {
	padding: 10px;
	width: 90%;
	border-radius: 5px;
	border: 1px solid darken(#eee, 20);
}
tr {
	td.green {
		font-weight: bold;
	}
	td:first-child {
		padding-left: 40px !important;
	}
	td:last-child {
		padding-right: 40px !important;
	}
}
.warning {
	color: red;
	font-size: 20px;
	padding: 7px 0px 0px;
}
.green {
	color: green;
}
</style>

<template>
	<tr>
		<td>
			<strong>{{ user.forename }} {{ user.surname }}</strong>
			<br />
			{{ user.email }}
		</td>
		<td>
			Parent: {{ parent.contact_forename }} {{ parent.contact_surname }}
			<br />
			Parental Responsibility: {{ parent.contact_parental_responsibility }}
			<br />
			Priority: {{ parent.contact_priority }}
		</td>
		<td>
			<input type="text" v-model="user.selectedParentRow.contact_email" />
		</td>
		<td style="text-align:center">
			<el-button @click="swap" :disabled="user.Parents.length < 2" plain>Swap</el-button>
		</td>
		<td
			style="text-align:center"
			:class="{ 'green': user.previousInvitations && user.previousInvitations.length }"
		>
			<el-popover
				placement="top-start"
				:title="`Invited email address${user.previousInvitations.length > 1 ? 'es' : ''}`"
				trigger="hover"
				v-if="user.previousInvitations && user.previousInvitations.length">
					<span slot="reference">Yes</span>
					<span slot="default">
						<ul>
							<li v-for="invitation in user.previousInvitations" :key="invitation.invitationId">
								{{ invitation.invitedEmailAddress }} <span :class="{ 'green': invitation.state === 'COMPLETE' }"> ({{ invitation.state }}) </span>
							</li>
						</ul>
					</span>
			</el-popover>
			<span v-else>No</span>
		</td>
		<td style="text-align:right">
			<el-button
				@click="user.selected = !user.selected"
				:type="type"
			>{{ user.selected ? "Selected" : "Excluded" }}</el-button>
		</td>
	</tr>
</template>

<script>
import _ from "lodash";

export default {
	props: {
		user: Object,
		sendTo: Array,
	},

	data() {
		return {
			selectedParent: 0
		};
	},

	computed: {
		parent() {
			return this.user.Parents[this.selectedParent];
		},

		type() {
			return this.user.selected ? "success" : "plain";
		},
		
		rowDuplicated() {
			const foundUser = _.find(this.sendTo, { personId: this.user.id });
			return (
				foundUser &&
				_(this.sendTo)
					.filter({ guardianEmail: foundUser.guardianEmail })
					.value().length > 1
			);
		},
	},

	methods: {
		swap() {
			if (this.user.Parents[this.selectedParent + 1]) {
				this.selectedParent++;
			} else {
				this.selectedParent = 0;
			}
			this.user.selectedParentRow = this.user.Parents[this.selectedParent];
		},
	}
};
</script>